
import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from "@/components/ui/button";
import AutomatedUpdatesManager from '@/components/admin/AutomatedUpdatesManager';

interface AdminControlsProps {
  isAdmin: boolean;
}

export const AdminControls: React.FC<AdminControlsProps> = ({ isAdmin }) => {
  if (!isAdmin) return null;

  return (
    <>
      <div className="mt-8">
        <div className="flex justify-center gap-4">
          <Link to="/upload">
            <Button>Upload New Data</Button>
          </Link>
          <Link to="/country-order">
            <Button>Manage Country Order</Button>
          </Link>
        </div>
      </div>

      <div className="mt-8">
        <AutomatedUpdatesManager />
      </div>
    </>
  );
};

export default AdminControls;
